import styled from 'styled-components';
import { m } from 'framer-motion';
import LinkWithQuery from '../LinkWithQuery';

export const LogoLink = styled(m(LinkWithQuery, { forwardMotionProps: true }))`
  position: relative;
  cursor: pointer;
  z-index: 13;
`;
